import {
    SEND_OTP_REQUEST_FAIL,
    SEND_OTP_REQUEST_START,
    SEND_OTP_REQUEST_SUCCESS,
} from './types';
import { LoadingEvent } from '../../../core/types/GeneralTypes';

type registerPartnerState = {
    sendOtpLoadingState: LoadingEvent,
    otpMessage: string | null
};

const INITIAL_STATE: registerPartnerState = {
    sendOtpLoadingState: 'UNINITIALIZED',
    otpMessage: null
};

export const reducer = (
    state: registerPartnerState = INITIAL_STATE,
    action: {
        type: string,
        payload?: any,
    }
): registerPartnerState => {
    switch (action.type) {
        case SEND_OTP_REQUEST_START:
            return {
                ...state,
                sendOtpLoadingState: 'LOADING'
            };

        case SEND_OTP_REQUEST_SUCCESS:
            return {
                ...state,
                sendOtpLoadingState: 'LOADED',
                otpMessage: action.payload
            };

        case SEND_OTP_REQUEST_FAIL:
            return {
                ...state,
                sendOtpLoadingState: 'ERROR'
            };

        default:
            return state;
    }
};